module.exports = __webpack_public_path__ + "img/root110.a6c63396.png";